import { useCustomSearchParams } from './useCustomSearchParams'

const GOOGLE_AUTH_ERROR_MESSAGES: Record<string, string> = {
  google_auth_failed:
    "Google isn't responding. Please try again or use your email.",
  forbidden_country:
    'Sorry! Currently, our platform is unavailable for users from your country',
}

export const useGoogleAuthError = (): string | null => {
  const { search } = useCustomSearchParams()
  const error = search.get('error')

  return error ? (GOOGLE_AUTH_ERROR_MESSAGES[error] ?? null) : null
}
